import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { responseDocumentClient } from '../../lib/connect/clients';
import { containerKey, toContainerRef } from './useOfficeWorkspace';
export const workspaceSourcesKey = (c, documentId, anchor)=>[
        'officeSources',
        containerKey(c),
        documentId ?? '',
        anchor ?? ''
    ];
/** `ListWorkspaceSources` for one section; idle until a section is picked. */ export function useWorkspaceSources(container, documentId, sectionAnchor) {
    return useQuery({
        queryKey: workspaceSourcesKey(container, documentId, sectionAnchor),
        enabled: !!documentId && !!sectionAnchor,
        queryFn: ()=>responseDocumentClient.listWorkspaceSources({
                container: toContainerRef(container),
                documentId: documentId ?? '',
                sectionAnchor: sectionAnchor ?? ''
            }),
        refetchOnWindowFocus: false
    });
}
/** `InsertSource`; success refreshes the workspace (citations, versions) and the sources. */ export function useInsertSource(container) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v)=>responseDocumentClient.insertSource({
                container: toContainerRef(container),
                operationId: crypto.randomUUID(),
                ...v
            }),
        onSuccess: ()=>Promise.all([
                qc.invalidateQueries({
                    queryKey: [
                        'officeWorkspace',
                        containerKey(container)
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        'officeSources',
                        containerKey(container)
                    ]
                }),
                qc.invalidateQueries({
                    queryKey: [
                        'officeVersions'
                    ]
                })
            ])
    });
}
